/**
 * Below Tailwind's `sm` breakpoint (640px) — the line the profile panel uses
 * to decide bottom-sheet (mobile) vs slide-over-from-left (desktop). A JS
 * hook rather than a pure CSS media query because the two layouts animate in
 * from different directions (up vs from the left), which framer-motion's
 * `initial`/`animate` props need to know as a value, not just a style rule.
 */
import { useEffect, useState } from 'react';

// 639.98 rather than 639: Tailwind's `sm:` fires at min-width 640px, so a
// viewport of e.g. 639.5px (fractional widths are normal under browser zoom and
// on some device pixel ratios) matched neither this hook nor `sm:` — the panel
// animated as desktop while the CSS around it was still mobile.
const QUERY = '(max-width: 639.98px)';

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(QUERY).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const onChange = () => setIsMobile(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
